import dayjs from 'dayjs';
import { computed, ref } from 'vue';

import type { SelectedDates } from '@entities/dates-picker';

const DATES_INITIAL_STATE = {
  from: '',
  to: '',
};

// TODO: Refactor this state and form store so we will work only with departure date and night amount

export function useDatepickerState() {
  const depDate = ref<SelectedDates>({ ...DATES_INITIAL_STATE });
  const arrDate = ref<SelectedDates>({ ...DATES_INITIAL_STATE });

  const isFlexibleDates = computed(
    () => depDate.value.from !== depDate.value.to,
  );

  const nightsDifferenceCount = computed(() => {
    if (!arrDate.value.from || !depDate.value.from) {
      return null;
    }

    return dayjs(arrDate.value.from).diff(depDate.value.from, 'day');
  });

  function setDepDate(date: SelectedDates) {
    depDate.value = date;
  }

  function setArrDate(date: SelectedDates) {
    arrDate.value = date;
  }

  function resetDatepickerState() {
    depDate.value = { ...DATES_INITIAL_STATE };
    arrDate.value = { ...DATES_INITIAL_STATE };
  }

  return {
    depDate,

    arrDate,

    nightsDifferenceCount,

    isFlexibleDates,

    setDepDate,
    setArrDate,

    resetDatepickerState,
  };
}
